(function () {
  const startTicker = () => {
    $(".brands-section").each(function () {
      const $section = $(this);
      const $ticker = $section.find(".brands-items");
      if ($section.hasClass("slider_started")) {
        return;
      }
      $section.addClass("slider_started");

      // Duplicate content once for seamless loop
      $ticker.append($ticker.html());

      // Measure half the content (original set)
      const halfWidth = $ticker[0].scrollWidth / 2;
      const speed = $section.data("brands-speed") || 50;
      const duration = (halfWidth / speed) * 1000;

      // Remove CSS animation, use JS transition loop
      $ticker.closest(".brands-wrapper").css("animation", "none");

      function animateTicker() {
        $ticker.css({
          transform: "translateX(0)",
          transition: "none",
        });

        // Force reflow before applying transition
        $ticker[0].offsetHeight;

        $ticker.css({
          transform: `translateX(-${halfWidth}px)`,
          transition: `transform ${duration}ms linear`,
        });

        $ticker.one("transitionend", () => {
          animateTicker();
        });
      }
      animateTicker();
    });
  };

  startTicker();
  document.addEventListener("shopify:section:load", function () {
    startTicker();
  });
})();
